import { render, staticRenderFns } from "./hanDongDate.vue?vue&type=template&id=22028b83&scoped=true"
import script from "./hanDongDate.vue?vue&type=script&lang=js"
export * from "./hanDongDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22028b83",
  null
  
)

export default component.exports